import React from 'react';
import LogItem from './LogItem';

const CommentLog = ({ event }) => {
  const details = {
    itemType: 'comment',
    actualItem: { text: event?.newComment },
    previousItem: { text: event?.oldComment },
    ...event
  };

  return (
    <LogItem event={ details }/>
  );
};

export default CommentLog;
